import { c as _c } from "react/compiler-runtime";
import { ButtonWithIcon } from '../buttons/buttonWithIcon';
const generateBucketPolicyUrl = (region: string, bucketName: string) => {
  return `https://${region}.console.aws.amazon.com/s3/bucket/${bucketName}/property/policy/edit?region=${region}&bucketType=general`;
};
export const VaultOwnBucketEditKeyPolicyButton = t0 => {
  const $ = _c(6);
  const {
    bucketName,
    region
  } = t0;
  const t1 = !bucketName;
  let t2;
  if ($[0] !== bucketName || $[1] !== region) {
    t2 = () => window.open(generateBucketPolicyUrl(region, bucketName), "_blank");
    $[0] = bucketName;
    $[1] = region;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t1 || $[4] !== t2) {
    t3 = <ButtonWithIcon variant="contained" disabled={t1} text="Edit Bucket Policy in AWS" icon="material-symbols-open-in-new" iconPosition="right" onClick={t2} />;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};